<pgh-modal-window class="file-a-claim-modal">
  <ng-container modal-title>
    <h4 class="file-a-claim-modal__title">{{ data?.FileClaimHeader }}</h4>
  </ng-container>

  <div modal-body>
    <mat-icon class="claim_icon" svgIcon="chat-clock"></mat-icon>
    <div class="mb-20">
      {{ data?.FileClaimInstructionText }}
    </div>
    <p class="">
      {{ data?.CallLabel }}
      <a [href]="'tel:' + data?.ClaimsPhoneNumber" class="link"> {{ data?.ClaimsPhoneNumber }}</a>
    </p>
    <div class="claim-divider">
      <div class="line">
        <mat-divider></mat-divider>
      </div>
      <div class="text mat-typography">{{ data?.OrLabel }}</div>
      <div class="line">
        <mat-divider></mat-divider>
      </div>
    </div>
    <button class="link" (click)="onClickChat()" gtmClick="Chat" gtmLinkURL="/account/file-a-claim">{{ data?.ChatLabel }}</button>
  </div>
  <div modal-footer>
    <button mat-flat-button color="accent" (click)="closeModal()">{{ data?.CloseButtonLabel }}</button>
  </div>
</pgh-modal-window>
